import React from 'react';
import { Box, Typography, styled } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import BusinessIcon from '@material-ui/icons/Business';
import LanguageIcon from '@material-ui/icons/Language';
import ScheduleIcon from '@material-ui/icons/Schedule';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { TimeZoneIcon } from '../icons/TimeZoneIcon';

const LABEL_ICON_MAP: Record<string, React.ReactElement> = {
  Email: <MailOutlineIcon />,
  'Phone Number': <PhoneIcon />,
  Company: <BusinessIcon />,
  Language: <LanguageIcon />,
  'Time format': <ScheduleIcon />,
  'Date format': <CalendarTodayIcon />,
  'Time Zone': <TimeZoneIcon />,
};

const Label = styled(Typography)({
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 700,
});

const Value = styled(Typography)({
  fontSize: 14,
  lineHeight: '24px',
  fontWeight: 400,
});

const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
  alignItems: 'start',
});

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.secondary,
}));

const TextWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const LabelWithLoader = ({
  label,
  loading,
  value,
}: {
  label?: string;
  loading?: boolean;
  value?: string;
}) => {
  if (!loading && !value) return null;

  return (
    <Wrapper>
      {loading && <Skeleton variant="text" height={22} width="50%" />}
      {value && (
        <>
          {label && <IconWrapper>{LABEL_ICON_MAP[label]}</IconWrapper>}
          <TextWrapper>
            {label && <Label variant="body2">{label}</Label>}
            {!loading && <Value variant="body2">{value}</Value>}
          </TextWrapper>
        </>
      )}
    </Wrapper>
  );
};
